import React from "react";
import './video_container.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";

class VideoContainer extends TemplateComponent {

    componentRender(data) {
        return (
            <div id='video_container'>
                <div className="container">
                    <div className="row justify-content-center flex-column-reverse flex-lg-row">
                        <div className="col-lg-3 left-side">
                            <div className="vertical-align-content">
                                <div className="title">{data.title}</div>
                                <div className="subtitle">{data.subtitle}</div>
                            </div>
                        </div>
                        <div className="col-lg-9 right-side">
                            <video className="video">
                                <source src="https://www.youtube.com/watch?v=S9QUWwMvcTM" type="video/mp4" />
                            </video>
                            <button className="video-player-button"></button>
                            <div className="video-player-button-shadow"></div>
                            <div className="triangle"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default VideoContainer;
